<div class="flex flex-col lg:mb-10">
  <img class="m-auto w-28 h-28" src="{{ imgSrc }}" alt="{{ imgAlt }}" />
  <h3 class="my-6 mx-auto w-11/12 text-center lg:my-10 overline" *ngIf="!!nicerHeader">
    <span class="text-2xl font-thin lg:text-4xl text-app-black">{{ nicerHeader | translate }}</span>
  </h3>
  <app-paragraph [paragraph]="paragraph"></app-paragraph>
</div>
